const NS = 'ResourcesBlock';
const CLS = 'resourcesBlock';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';
import { utils } from '../../../../global/js/utils';

export class ResourcesBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$cardLink = this.$element.find(`.${CLS}-card-link`);
		this.$modal = this.$element.find(`.modal`);
		this.$iframe = this.$modal.find('.videoBlock-iframe');

		this.videoSrcId = this.$cardLink.data('videoSrcId');
		this.imageSrc = this.$cardLink.data('imageSrc');
		this.videoLocalSrc = this.$cardLink.data('videoLocalSrc');
		this.videoType = this.$cardLink.data('videoType');

		this.$cardLink.on('click', () => {
			if(this.$cardLink.attr(`data-type`) === 'video') {
				this.showVideo();
			}
			else if(this.$cardLink.attr(`data-type`) === 'image') {
				this.showImage();
			}
		});
		this.initFullWindowHeight(this);
	}

	// Video Modal
	showVideo() {
		this.$modal.addClass('modal--black');

		if(this.videoSrcId) {
			if (this.$iframe.length === 0) return;
			let embedLink = '';

			switch (this.videoType) {
				case utils.VID_TYPE.youku:
					embedLink = `https://player.youku.com/embed/${this.videoSrcId}?autoplay=1&rel=0`;
					break;

				default:
					// set default as youtube
					embedLink = `https://www.youtube.com/embed/${this.videoSrcId}?autoplay=1&showinfo=0&controls=0&rel=0`;
					break;
			}

			this.$modal.modal('show');
			$('.modal-backdrop').addClass('modal-backdrop--black');
			this.$iframe.attr('src', embedLink);
		}
		// Local file
		else if(this.videoLocalSrc) {
			this.$modal.modal('show');
			let $video = this.$modal.find('video');
			$('.modal-backdrop').addClass('modal-backdrop--black');

			$video[0].play();
		}
		else {
			console.error(`${NS}::Error`, 'Please supply a video-src-id to load a video on the modal.');
		}

		this.$modal.on('hidden.bs.modal', () => {
			// Embed
			if(this.videoSrcId) {
				this.$iframe.removeAttr('src');
			}
			// Local File
			else if(this.videoLocalSrc) {
				let $video = this.$modal.find('video');
				$video[0].pause();
				$video[0].currentTime = 0;
			}
		});
	}

	// Image Modal
	showImage() {
		this.$modal.addClass('modal--black');

		if(this.imageSrc) {
			this.$modal.modal('show');
			$('.modal-backdrop').addClass('modal-backdrop--black');
		}
		else {
			console.error(`${NS}::Error`, 'Please supply a img-src to load an image on the modal.');
		}
	}
}

Object.assign(ResourcesBlock.prototype, fullWindowHeightMixinBlock);
